export default class ProjectsListCtrl {
  constructor ($scope, $stateParams, $timeout, WorkPlanSrv, WorkPlanModalSrv, GlobalConfig, $cookies, $state, $mdDialog, $filter, Requests, $sessionStorage) {
  // constants
    const projectsVm = this
    const currentUser = JSON.parse($cookies.get('currentUser'))
    let post = {
      teacherId: currentUser.teacherId,
      workplanId: currentUser.workplanId
    }

  // variables
    projectsVm.projectsList = []
    projectsVm.viewLoaded = true
    projectsVm.criteriaFilter = ''
    projectsVm.selectedProject = null
    projectsVm.projectParent = null
    projectsVm.isLoadingDetails = false
    projectsVm.imgEmpty = require('../../../../../../assets/images/empty_state_illustration.svg')
    projectsVm.active = GlobalConfig.generals.active
    projectsVm.notActive = GlobalConfig.generals.notActive
    projectsVm.planningFinish = true
    $scope.classPlanning = ''
    projectsVm.sr = ''
    projectsVm.searchValue = false
    projectsVm.feedback = 0
    projectsVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList
    projectsVm.$sessionStorage = $sessionStorage

  // methods
    projectsVm.projectBckgrd = projectBckgrd
    projectsVm.projectText = projectText
    projectsVm.details = details
    projectsVm.close = close
    projectsVm.updateFilter = updateFilter
    projectsVm.addActivityProject = addActivityProject
    projectsVm.getGeneralsWorkplan = getGeneralsWorkplan
    projectsVm.searchResult = searchResult
    projectsVm.bitacora = bitacora

    // data validations
    projectsVm.thereIsDetails = thereIsDetails
    projectsVm.showNotification = () => {
      WorkPlanSrv.updateIsNotification.post({
        workplanTeacherActivityId: projectsVm.projectParent.workplanTeacherActivityId,
        isNotification: Number(projectsVm.isNotification)
      }).$promise.then(dataReturn => {
        if (dataReturn.status) {
          projectsVm.projectParent.isNotification = Number(!projectsVm.projectParent.isNotification)
        } else {
          projectsVm.isNotification = Boolean(projectsVm.projectParent.isNotification)
        }
      })
    }

  // services

    activate()

    function activate () {
      if(projectsVm.workPlanGeneralList != undefined){
        projectsVm.status = projectsVm.workPlanGeneralList.wokplanTeacherStatus[0]
        projectsVm.stages = projectsVm.workPlanGeneralList.stages
        projectsVm.feedback = projectsVm.status.feedbackReviewed
        projectsVm.workplanTeacherId = projectsVm.status.workplanTeacherId
        isPlanning(projectsVm.status, projectsVm.stages)
        
        if(projectsVm.feedback && !projectsVm.planningFinish){
            getDataFormProjectsReject()
          }else{ 
            getDataFormProjects() 
          }
      }else{
        getGeneralsWorkplan(post).then((promise) => {
          if(projectsVm.feedback && !projectsVm.planningFinish){
            getDataFormProjectsReject()
          }else{ 
            getDataFormProjects() 
          }
        })
      }
    }

    function getDataFormProjects () {
      WorkPlanSrv.getDataFormProjects.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            projectsVm.projectsList = dataReturn.listProjects

            if (projectsVm.projectsList.length == 0) {
              projectsVm.projectParent = 0
            }

            if (projectsVm.projectsList && projectsVm.projectsList.length > 0) {
              projectsVm.details(projectsVm.projectsList[0])
            }
          } else {
            console.log('Comunications problem')
          }
        },
        data => {
          console.log()
        }
      )
    }

    function getDataFormProjectsReject () {
      WorkPlanSrv.getDataFormProjectsReject.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            projectsVm.projectsList = dataReturn.listProjects

            if (projectsVm.projectsList.length == 0) {
              projectsVm.projectParent = 0
            }

            if (projectsVm.projectsList && projectsVm.projectsList.length > 0) {
              projectsVm.details(projectsVm.projectsList[0])
            }
          } else {
            console.log('Comunications problem')
          }
        },
        data => {
          console.log()
        }
      )
    }

    function validateSearch () {
      return $filter('filter')(projectsVm.projectsList, projectsVm.criteriaFilter)
    }

    function searchResult () {
      projectsVm.sr = validateSearch()
    }

    function getProjectDetails (project, reload = false) {
      WorkPlanSrv.getProjectByActivityId.get({workplanTeacherActivityId: project.workplanTeacherActivityId}).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            projectsVm.projectParent = dataReturn.data.parent
            projectsVm.isNotification = Boolean(projectsVm.projectParent.isNotification)
            projectsVm.projectChilds = dataReturn.data.childs
          } else {
            console.log('Comunications problem')
          }
        },
        data => {
          console.log()
        }
      )

      if (!reload) {
        projectsVm.isLoadingDetails = true
        projectsVm.projectParent = null
      }
    }

    function thereIsDetails () {
      return projectsVm.projectParent !== null
    }

    function projectBckgrd (project) {
      if (projectsVm.selectedProject === project) {
        return 'bg-review'
      }
    }

    function projectText (project) {
      if (projectsVm.selectedProject === project) {
        return 'text-color-w'
      }
    }

    function details (project) {
      projectsVm.selectedProject = project
      getProjectDetails(project)
    }

    function close () {
      return $mdDialog.hide()
    }

    function updateFilter (val) {
      projectsVm.criteriaFilter = val
      projectsVm.sr = validateSearch()
      if (projectsVm.sr.length == 0) {
        projectsVm.searchValue = true
        projectsVm.projectParent = null
      } else {
        projectsVm.searchValue = false
        if (projectsVm.projectsList && projectsVm.projectsList.length > 0) { projectsVm.details(projectsVm.projectsList[0]) }
      }
    }

    function addActivityProject (project, activity) {
      activity.hoursChildren = project.hoursChildren
      let header = {
        workplanTeacherActivityIdParent: project.workplanTeacherActivityId,
        children: activity || 'ADD'
      }
      WorkPlanModalSrv.setVariable(header)
      WorkPlanModalSrv.addActivityProject().then((promise) => {
        let shared = WorkPlanModalSrv.getVariable()
        if (shared.status) {
          // getProjectDetails(project)
          if (shared.action == 'ADD') {
            projectsVm.projectChilds.push(shared.child)
          } else {
            for (var i = projectsVm.projectChilds.length - 1; i >= 0; i--) {
              if (projectsVm.projectChilds[i].workplanTeacherActivityId == shared.child.workplanTeacherActivityId) {
                projectsVm.projectChilds[i].name = shared.child.name
                projectsVm.projectChilds[i].hoursPlanned = shared.child.hoursPlanned
                projectsVm.projectChilds[i].description = shared.child.description
                projectsVm.projectChilds[i].timeRangeTypeId = shared.child.timeRangeTypeId
                projectsVm.projectChilds[i].periodId = shared.child.periodId
                projectsVm.projectChilds[i].endDate = shared.child.timeRangeTypeId == GlobalConfig.periods.rangeType ? null : moment(shared.child.endDate).format('YYYY-MM-DD')
                projectsVm.projectChilds[i].startDate = shared.child.timeRangeTypeId == GlobalConfig.periods.rangeType ? null : moment(shared.child.startDate).format('YYYY-MM-DD')
              }
            }
          }
        }
        if(promise){getDataFormProjects()}
      })
    }

    function getGeneralsWorkplan (post) {
      return WorkPlanSrv.getElementsRightBar.getList({teacherId: post.teacherId}).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          projectsVm.$sessionStorage.workPlanGeneralList = dataReturn.data
          projectsVm.status = dataReturn.data.wokplanTeacherStatus[0]
          projectsVm.stages = dataReturn.data.stages
          projectsVm.feedback = projectsVm.status.feedbackReviewed
          projectsVm.workplanTeacherId = projectsVm.status.workplanTeacherId
          isPlanning(projectsVm.status, projectsVm.stages)
        } else {
          console.log('Comunications problem with the server')
        }
      }, function (data) {
        console.log(data)
      })
    }

    function isPlanning (status, stages) {
      projectsVm.currentDate = moment(new Date()).format('DD/MM/YYYY')
      for (var i = stages.length - 1; i >= 0; i--) {
        if (stages[i].stageId == GlobalConfig.workplanIdStages.review) {
          projectsVm.startDateStage = stages[i].startDate
        }
      }

      if (status.planningFinish == projectsVm.active) {
        projectsVm.planningFinish = true
        if (projectsVm.startDateReview < projectsVm.currentDate || status.reviewedFinish == projectsVm.active) {
          projectsVm.planningFinish = true
        } else if (status.reviewedReject == projectsVm.active) {
          projectsVm.planningFinish = false
        }
      } else {
        projectsVm.planningFinish = false
      }
      $scope.classPlanning = (projectsVm.planningFinish ? 'disabled' : ' ')
    }

    function bitacora (ev) {
      let entries = {}

      entries.params = {
        activityTypeId: GlobalConfig.activityTypeId.projects,
        workplanTeacherId: projectsVm.workplanTeacherId
      }
      entries.title = 'Proyectos'
      // Entries(this.entries);
      entries.data = undefined
      $mdDialog.show({
        controller: 'bitacoraModalCtrl',
        controllerAs: 'bit',
        template: require('../../../../strategicTracking/detailsByTeacher/bitacoraModal/bitacoraModal.html'),
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {data: entries},
        clickOutsideToClose: true,
        fullscreen: true
      })
    }
  }
}

ProjectsListCtrl.$inject = ['$scope', '$stateParams', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', 'GlobalConfig', '$cookies', '$state', '$mdDialog', '$filter', 'Requests', '$sessionStorage']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/research/projects/list/projectsListCtrl.js